/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CancellationReasonEnum } from './cancellationReasonEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CategorizedCancellationReason { 
    readonly patientReasons: Array<CancellationReasonEnum>;
    readonly internalReasons: Array<CancellationReasonEnum>;
}
export const CategorizedCancellationReason_patientReasons_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CategorizedCancellationReason_internalReasons_Validators: ValidatorFn[] =
    [  Validators.required, ];


